import styles from "./EntityTypeToggle.module.scss";
import { useSelector } from "react-redux";
import { getDataset } from "../../../../../../redux/SingleDataset/selectors";
import { Dataset } from "../../../../../../types";
import { PlusIcon } from "./Icons";
import { useEntityTypeFilter } from "../../../../../../hooks/useEntityTypeFilter";
import { useParams } from "react-router";
import ObjectIcon from "../../../../../../assets/icons/ObjectIcon";
import ImageIcon from "../../../../../../assets/icons/imageIcon";
import FrameIcon from "../../../../../../assets/icons/frameIcon";
import { VLSegmented } from "../../../../../uikit/VLSegmented/VLSegmented";
import { Tooltip } from "antd";

const formatEmptyMessage = (type: string) =>
  `Looks like there are no ${type} in this dataset yet`;

export const EntityTypeToggle = () => {
  const { datasetId } = useParams();
  const dataset: Dataset = useSelector(getDataset);

  const {
    handleFilterSelection,
    entityTypeFilter: options,
    selectedEntityTypes: [selectedEntityType],
  } = useEntityTypeFilter({
    datasetId: datasetId!,
    onSelect: () => null,
  });
  const hasObjects = Boolean(dataset.n_objects);
  const hasImages = Boolean(dataset.n_images);
  const hasVideoFrames = Boolean(dataset.n_video_frames);
  const hasImagesAndFrames = hasImages && hasVideoFrames;
  const hasImagesOrFrames = hasImages || hasVideoFrames;
  const objectsLabel = "Objects";
  const objectsLabelLower = "objects";
  const renderIcons = (type: string) => {
    if (type === "OBJECTS") {
      return (
        <Tooltip
          title={
            hasObjects ? objectsLabel : formatEmptyMessage(objectsLabelLower)
          }
        >
          <>
            <ObjectIcon />
          </>
        </Tooltip>
      );
    }
    return (
      <Tooltip
        title={
          !hasImagesOrFrames
            ? formatEmptyMessage("images")
            : hasImagesAndFrames
              ? "Images + Frames"
              : hasImages
                ? "Images"
                : "Frames"
        }
      >
        <>
          {(hasImages || !hasImagesOrFrames) && <ImageIcon />}
          {hasImagesAndFrames && <PlusIcon />}
          {hasVideoFrames && <FrameIcon />}
        </>
      </Tooltip>
    );
  };

  const enabledByType: Record<string, boolean> = {
    OBJECTS: hasObjects,
    IMAGES: hasImagesOrFrames,
  };
  return (
    <VLSegmented
      gradientToggle
      className={styles.entityTypeToggle}
      value={selectedEntityType.id}
      onChange={(id) => handleFilterSelection(String(id))}
      options={[...options].reverse().map(({ id, text }) => ({
        value: id,
        label: <div className={styles.iconContainer}>{renderIcons(text)}</div>,
        disabled: !enabledByType[text],
      }))}
      shape="round"
      size="large"
    />
  );
};
